import type React from "react";
import { Link } from "react-router";
import { Navigation } from "../navigation";
import styles from "./Header.styles";

export const Header: React.FC = () => {
	return (
		<header css={styles.container}>
			<Link to="/">
				<div css={styles.heading}>
					<img
						src="/icons/logo.png"
						height={40}
						width={40}
						alt="logo"
						loading="eager"
					/>
					<h1>Udruga &bdquo;4 lista&rdquo;</h1>
				</div>
			</Link>
			<Navigation />
		</header>
	);
};
